import { useFetchData, useParseRouteActions } from "../../../helpers/GlobalHelper";
import LmsFormGenerator, { BCFormController } from "../ui/LmsFormGenerator";
import LmsTable from "../ui/LmsTable";
import { IdProps } from "../../interfaces/Global";

const MainTable = () => {
  const actionButtons = ["add", "edit", "remove", "export"];
  return (
    <LmsTable
      actionButtons={actionButtons}
      apiSuffix="menu/validation-message"
      deleteSuffix="menu/validation-message"
      sortable={[
        "Display",
        "Name", 
        "Action",
        "Condition",
        "Validation Message Type",
        "Is Active",
        "Description",
        "Created On",
        "Created By",
        "Updated On",
        "Updated By"
      ]}
    />
  );
};

const validationMessageFields = (myForm: BCFormController) => {
  myForm.addCenteredGroup([
    myForm.getInputField("Reference No", { required: true }),
    myForm.getDropdownField("Portal", "", { // TODO: Sprint Work 13594
      name: "portalId",
      required: true,
    }),
  ]);

  myForm.addCenteredGroup([
    myForm.getInputField("Portal Functionality", { required: true }),
    myForm.getDropdownField("Validation Message Type", "", { // TODO: Sprint Work 13594
      name: "validationMessageTypeId",
    }),
  ]);

  myForm.addCenteredGroup([
    myForm.getTextareaField("Name", { required: true }),
  ]);

  myForm.addCenteredGroup([
    myForm.getTextareaField("Action", { required: true }),
  ]);

  myForm.addCenteredGroup([
    myForm.getTextareaField("Condition", { required: true }),
  ]);

  myForm.addCenteredGroup([
    myForm.getTextareaField("Message", { required: true }),
  ]);

  myForm.addCenteredGroup([
    myForm.getCheckboxField("Is Active", { value: true, inline: true }),
    myForm.getInputField("Sort Order", { required: true, inline: true }),
  ]);

  myForm.addCenteredGroup([
    myForm.getTextareaField("Description"),
  ]);

  return myForm;
};

const EditNewMenusValidationMessageForm = ({ id }: IdProps) => {
  const [{ data = {}, isLoading, error }] = useFetchData(`menu/validation-message/${id}`);
  const myForm = new BCFormController(data, { 
    submitSuffix: "menu/validation-message", 
    submitMethod: "PUT", 
    deleteSuffix: "menu/validation-message",
    blankWidth: 4 
  });
  validationMessageFields(myForm);
  const formActions = ["save", "save-close", "delete", "close"];
  return (
    <LmsFormGenerator
      myForm={myForm}
      isLoading={isLoading}
      error={error}
      actions={formActions}
    />
  );
};

const AddNewMenusValidationMessageForm = () => {
  const myForm = new BCFormController({}, { submitSuffix: "menu/validation-message", submitMethod: "POST", blankWidth: 4 });
  validationMessageFields(myForm);
  const formActions = ["save-new", "save-continue", "save-close", "close"];
  return <LmsFormGenerator myForm={myForm} actions={formActions} />;
};

const LmsNewMenusValidationMessage = ({ params = {}, history }) => {
  const { isMainPage, isAdd, isEdit, isActionAllowed, id } =
    useParseRouteActions(params);
  if (!isActionAllowed) {
    history.goBack();
  }

  return (
    <>
      {isMainPage && <MainTable />}
      {isAdd && <AddNewMenusValidationMessageForm />}
      {isEdit && <EditNewMenusValidationMessageForm id={id} />}
    </>
  );
};

export default LmsNewMenusValidationMessage;
